import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { CompanyContextService } from '../services/company-context.service';
import { UpgradePromptService } from '../services/upgrade-prompt.service';
import { FeatureCategory } from '../config/feature-permissions';

/**
 * Kilitli (özellik izni olmayan) sayfalara doğrudan URL ile erişimi engeller: panoya
 * yönlendirir ve yükseltme (upsell) dialogunu açar. İzin haritası bilinmiyorsa (null) erişime
 * izin verir (sidebar ile aynı graceful-fallback). `featureLabelKey` verilirse dialog başlığı
 * o özelliğin adıyla kişiselleştirilir.
 */
export function featurePermissionGuard(
  category: FeatureCategory,
  child?: string,
  featureLabelKey?: string,
): CanActivateFn {
  return () => {
    const companyContext = inject(CompanyContextService);
    const router = inject(Router);

    if (companyContext.hasFeaturePermission(category, child)) return true;

    const upgradePrompt = inject(UpgradePromptService);
    const transloco = inject(TranslocoService);
    upgradePrompt.openPrompt(featureLabelKey ? transloco.translate(featureLabelKey) : undefined);
    return router.createUrlTree(['/dashboard']);
  };
}
